// extracted by mini-css-extract-plugin
export default {"bat-figure":"BatFigure_bat-figure__55q6f"};